export const CREATE_EDIT_KITCHEN_PREP_WORKSHEET_LOADING =
  'CREATE_EDIT_KITCHEN_PREP_WORKSHEET_LOADING';
export const CREATE_EDIT_KITCHEN_PREP_WORKSHEET_DATA =
  'CREATE_EDIT_KITCHEN_PREP_WORKSHEET_DATA';
export const CREATE_EDIT_KITCHEN_PREP_WORKSHEET_ERROR =
  'CREATE_EDIT_KITCHEN_PREP_WORKSHEET_ERROR';
export const CREATE_EDIT_NEEDED_PREPARED_DIFF =
  'CREATE_EDIT_NEEDED_PREPARED_DIFF';
export const CLEAR_KITCHEN_ERROR = 'CLEAR_KITCHEN_ERROR';
export const KITCHEN_PREP_WORKSHEET_SUBMITTING =
  'KITCHEN_PREP_WORKSHEET_SUBMITTING';
export const KITCHEN_PREP_WORKSHEET_SUBMIT = 'KITCHEN_PREP_WORKSHEET_SUBMIT';
export const KITCHEN_PREP_WORKSHEET_SUBMIT_ERROR =
  'KITCHEN_PREP_WORKSHEET_SUBMIT_ERROR';
export const FETCHING_KITCHEN_PREP_DETAIL = 'FETCHING_KITCHEN_PREP_DETAIL';
export const SELECTED_KITCHEN_PREP_DETAIL = 'SELECTED_KITCHEN_PREP_DETAIL';
export const FETCHING_KITCHEN_PREP_DETAIL_ERROR =
  'FETCHING_KITCHEN_PREP_DETAIL_ERROR';



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/createEditKitchenPrepWorksheet/types.js